module.exports = __webpack_public_path__ + "img/logarithmic_gmt.74a4f643.gif";